export default "__VITE_ASSET__DIBcuQje__"